module.exports = __webpack_public_path__ + "static/media/centro-distribuicao.a192807b.png";